import { env } from '../config.js';

export async function createExperiment(token, name, description, timeoutPeriod, parts) {
    var data = {name: name, description: description, timeoutPeriod: timeoutPeriod, parts: parts};
    const response = await fetch(env.BACKEND_URL + '/experiments',
    {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    });
    return await response;
}

export async function uploadExperimentImport(token, file) {
    var formData = new FormData();
    formData.append("jsonFile", file);

    const response = await fetch(env.BACKEND_URL + '/experiments/import',
    {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token
        },
        body: formData
    });
    return await response;
}

export async function copyExperiment(token, id) {
    const response = await fetch(env.BACKEND_URL + '/experiments/copy/' + id,
    {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}

export async function updateExperiment(token, id, name, timeoutPeriod, description, parts) {
    var data = {name: name, timeoutPeriod: timeoutPeriod, description: description, parts: parts};
    const response = await fetch(env.BACKEND_URL + '/experiments/' + id,
    {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    });
    return await response;
}

export async function changeExperimentState(token, id, transferState) {
    var data = {id: id, transferState: transferState};
    const response = await fetch(env.BACKEND_URL + '/experiments/state/change',
    {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    });
    return await response;
}

export async function getExperimentDetail(token, id) {
    const response = await fetch(env.BACKEND_URL + '/experiments/' + id,
    {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response.json();
}

export async function getExperimentExport(token, id) {
    const response = await fetch(env.BACKEND_URL + '/experiments/export/' + id,
    {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}

export async function getPartChartsDetail(token, id) {
    const response = await fetch(env.BACKEND_URL + '/experiments/part/' + id,
    {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    if (!response.ok) return null;
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export async function listExperiments(token, page = 0) {
    const response = await fetch(env.BACKEND_URL + '/experiments?page=' + page + '&sort=experiment.id,ASC',
    {
        headers: {'Authorization': 'Bearer ' + token}
    });
    return await response.json();
}

export async function deleteExperiment(token, id) {
    const response = await fetch(env.BACKEND_URL + '/experiments/' + id,
    {
        method: 'DELETE',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}
